import useLangText from '@shared/hooks/useLangText';
import {
    ProcessFieldBase,
    type ProcessFieldInt as ProcessFieldIntType,
} from '@shared/types/process';

import {
    maskitoNumberOptionsGenerator,
    MaskitoNumberParams,
} from '@maskito/kit';
import { ShadcnForm } from '@shadcn-features/core';
import { ShadcnFormInputNumberProps } from '@shadcn-features/core/ShadcnForm/fields/ShadcnFormInputNumber';

interface Props extends ShadcnFormInputNumberProps<
    typeof ShadcnForm.InputNumber
> {
    field: ProcessFieldBase & ProcessFieldIntType;
}

export function ProcessFieldIntField({ field, fieldProps, ...props }: Props) {
    const getLangText = useLangText();

    const maskitoNumberParams: MaskitoNumberParams = {
        thousandSeparator: field.options.thousandSeparator ?? ' ',
        max:
            field.options.maxValue != null
                ? Number(field.options.maxValue)
                : undefined,
        min:
            field.options.minValue != null
                ? Number(field.options.minValue)
                : undefined,
    };

    const params = maskitoNumberOptionsGenerator(maskitoNumberParams);

    return (
        <ShadcnForm.InputNumber
            {...props}
            fieldProps={fieldProps}
            maskito={params}
            maskitoNumberParams={maskitoNumberParams}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            rules={props.rules}
            tooltip={getLangText(field?.tooltip ?? '')}
            type='text'
        />
    );
}
